var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/XPActionBase',["require", "exports", "score_ccf/XPerience/XPElementBase"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var XPElementBase_1 = require("score_ccf/XPerience/XPElementBase");
    /**
     * Encapsulated basic logic for an Action
     */
    var XPActionBase = /** @class */ (function (_super) {
        __extends(XPActionBase, _super);
        function XPActionBase(attributes) {
            return _super.call(this, attributes) || this;
        }
        /**
         * Execute the action logic
         * @param {UXModuleLike} component An instance of a UXModule component to scope the current action
         */
        XPActionBase.prototype.execute = function (component) {
            throw new Error("Execute action is not implemented");
        };
        return XPActionBase;
    }(XPElementBase_1.XPElementBase));
    exports.XPActionBase = XPActionBase;
});
//# sourceMappingURL=XPActionBase.js.map;
